/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'
import {isReddata} from '../../../../app/utils/helperFunction/_helper'

const Footer = () => {
  const {config} = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <div className='d-flex justify-content-between align-items-center w-100'>
      <div className='text-dark'>
        {!isReddata() ? (
          <>
            <span className='text-muted fw-semibold me-1'>
              {new Date().getFullYear().toString()}&copy;
            </span>
            <a
              href='https://iatlbd.com/'
              target='_blank'
              className='text-gray-800 text-hover-primary'
            >
              Intelligent Automation Technology Ltd
            </a>
          </>
        ) : null}
      </div>

      <span>v1.0.12</span>
    </div>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
